import { Divider, Stack } from '@ekhodealer/ekho-common/rev';

import { AccessoriesSection } from './AccessoriesSection';
import { BuyerDetailsSection } from './BuyerDetailsSection';
import { OverviewSection } from './OverviewSection';
import { PaymentSection } from './PaymentSection';
import { VehicleSection } from './VehicleSection';

export const DetailsTabContent = (): React.ReactNode => {
	return (
		<Stack>
			<OverviewSection />
			<Divider />
			<BuyerDetailsSection />
			<Divider />
			<VehicleSection />
			<Divider />
			<AccessoriesSection />
			<Divider />
			<PaymentSection />
		</Stack>
	);
};
